export default {
      id: "moneyback-refund-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#moneyback-refund",
      toString: function () {
        return this.url;
      }
    }